import React from 'react';
import { ImageMetadata } from '../../../helpers/images/mediaApiUtils';
import { ProgressBar } from '@xo-union/tk-component-progress-bar';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { Formik, Field as FormikField } from 'formik';
import { Textarea, DateDropdown } from '../../../libs/gs-component-form';
import * as Yup from 'yup';
import styles from './PhotoUploadRow.scss';
import AutoSave from './AutoSave';

interface Props {
  metadata: ImageMetadata;
  percentUploaded: number;
  onChange: (metadata: ImageMetadata) => void;
  onError: () => void;
}

const validationSchema = Yup.object().shape({
  date: Yup.string()
    .trim()
    .matches(/\d{4}-\d{2}-\d{2}/)
    .required(),
  caption: Yup.string(),
});

const PhotoUploadRow: React.FC<Props> = ({ percentUploaded, metadata: { date, caption }, onChange, onError }) => {
  const initialValues = {
    date,
    caption,
  };

  if (percentUploaded !== 100) {
    return <ProgressBar progress={percentUploaded / 100} color="green" />;
  }

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onChange} enableReinitialize>
      {({ setFieldValue }) => (
        <div className={styles.formBlockContainer}>
          <FormBlockColumn>
            <FormikField
              name="date"
              label="Date of Memory"
              component={DateDropdown}
              setFieldValue={setFieldValue}
              data-testid="memory-date"
              readOnly={false}
            />
          </FormBlockColumn>
          <FormBlockColumn>
            <FormikField name="caption" label="" component={Textarea} data-testid="photo-caption" />
          </FormBlockColumn>
          <AutoSave onError={onError} />
        </div>
      )}
    </Formik>
  );
};

export default PhotoUploadRow;
